<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Nueva contraseña
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Ingresa tu nueva contraseña para completar el proceso.
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="space-y-6" @submit.prevent="handleReset">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Confirmar Correo electrónico
            </label>
            <div class="mt-1">
              <input id="email" name="email" type="email" required v-model="form.email"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              Nueva Contraseña
            </label>
            <div class="mt-1">
              <input id="password" name="password" type="password" required v-model="form.password"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <label for="password_confirmation" class="block text-sm font-medium text-gray-700">
              Confirmar Nueva Contraseña
            </label>
            <div class="mt-1">
              <input id="password_confirmation" name="password_confirmation" type="password" required v-model="form.password_confirmation"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm">
            </div>
          </div>

          <div>
            <button type="submit" :disabled="loading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50">
              <span v-if="loading">Procesando...</span>
              <span v-else>Cambiar contraseña</span>
            </button>
          </div>

          <div v-if="error" class="text-red-600 text-sm text-center mt-2">
            {{ error }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'ResetPassword',
  data() {
    return {
      form: {
        token: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      loading: false,
      error: null
    }
  },
  created() {
    this.form.token = this.$route.query.token
    this.form.email = this.$route.query.email || ''
    if (!this.form.token) {
      this.$router.push('/login')
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async handleReset() {
      if (this.form.password !== this.form.password_confirmation) {
        this.error = 'Las contraseñas no coinciden.'
        return
      }

      this.loading = true
      this.error = null
      try {
        const response = await this.resetPassword(this.form)
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        })

        Toast.fire({
          icon: 'success',
          title: response.message
        })

        this.$router.push('/?login=true')
      } catch (err) {
        this.error = err.response?.data?.message || 'Ocurrió un error al restablecer la contraseña.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
